import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";
import { Mutation } from "vuex-class";

import Field from '@/../bower_components/teknisavuecomponents/assets/interfaces/Field';
import LoginController from '@/assets/ts/controller/LoginController';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import TkField from '@/../bower_components/teknisavuecomponents/components/fields/TkField.vue';
import TkForm from '@/../bower_components/teknisavuecomponents/components/TkForm.vue';
import PopupController from '@/assets/ts/controller/PopupController';
import Messages from '@/assets/ts/utils/Messages';
// import EditableTable from '@/../bower_components/teknisavuecomponents/components/grids/EditableTable.vue';

@Component({
  name: 'ResetPassword',
  components: {
    TkField,
    TkForm,
  },
})
export default class ResetPassword extends Vue {
  // [ PROPS ]
  @Prop({ default: null})
  private name: string;

  @Prop({ default: (): any => null})
  private closeAction: () => void;

  @Prop({ default: () => {}})
  private defaultRow: any;

  @Prop({ default: false })
  private isVisible: boolean;
  // [ PROPS ]

  // [ DATA ]
  private tkForm: any = {
    row: {},
    loading: false,
  };

  private screen = {
    title: 'Redefinir Senha',
  };

  private actions = {
    close: this.close,
    save: this.resetPassword,
    saveDisabled: false,
  }
  // [ DATA ]

  // [ STORE ]
  @Mutation('controlPopUp')
  private controlPopUp: (popUp: {[key: string]: any, popUp: string}) => void;
  // [ STORE ]

  // [ COMPUTED ]
  private get fields(): Field[] {
    const f: Field[] = [
      {
        name: 'EMAIL',
        label: 'Usuário',
        size: 12,
        type: 'text',
        readonly: false,
        required: true,
      },
    ];

    return f;
  }
  // [ COMPUTED ]

  // [ EMIT ]
  @Emit('close-popup')
  private close() {
    this.tkForm.row = {};
  }
  // [ EMIT ]

  // [ METHODS ]
  @Watch('isVisible', { immediate: true, deep: true })
  private isVisibleOnChange(newValue: boolean) {
    if (newValue) {
      this.tkForm.row = { ...this.tkForm.row, ...this.defaultRow };
    }
  }
  private async resetPassword() {
    if (!this.tkForm.row.validate()) {
      SnackbarUtils.showMessage(Messages.REQUIRED_FIELDS_NOT_FILLED, SnackbarUtils.TYPE_ALERT);
      return;
    }

    this.beforeRequest();
    const response = await LoginController.resetPassword(this.tkForm.row.EMAIL);
    this.afterRequest();
    if (!response.success) {
      SnackbarUtils.showMessage(response.message, SnackbarUtils.TYPE_ERROR);
      return;
    }

    SnackbarUtils.showMessage(Messages.PASSWORD_RESETED_SUCESS, SnackbarUtils.TYPE_SUCCESS);
    this.actions.close();
  }

  private beforeRequest() {
    this.tkForm.loading = true;
    this.actions.saveDisabled = true;
  }

  private afterRequest() {
    this.tkForm.loading = false;
    this.actions.saveDisabled = false;
  }
  // [ METHODS ]
}